import { deleteApiWrapper, getApiWrapper, postApiWrapper, putApiWrapper } from "./token-wrapper-function";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
/**
 * Retrieves data of users.
 * @returns {Array} An array of user objects.
 */


/**
 * Retrieves all users.
 * @returns {Array} An array of user objects.
 */

const base_url = 'https://y71-dashboard.y-71.com'

export const getAllUsers = async() => {
  const response = await getApiWrapper(`${base_url}/users/get-users`);
  console.log('getAllUsers', response);
  return response;
};



export const createUser = (user) => {
  const response = postApiWrapper(`${base_url}/users/create-user`, user);
  console.log('createUser', response);
  return response;
}

export const updateUser = (user, id) => {
  const response = putApiWrapper(`${base_url}/users/update-user/`+id, user);
  return response;
} 

export const deleteUser = (id) => {
  const response = deleteApiWrapper(`${base_url}/users/delete-user/${id}`);
  return response;
}

export const getCurrentUser = async() => {
  const response = await getApiWrapper(`${base_url}/get-current-user`);
  return response;
}



//org user APIs

